import { render, staticRenderFns } from "./BadgeEntry.vue?vue&type=template&id=341f87cd&scoped=true"
import script from "./BadgeEntry.vue?vue&type=script&lang=js"
export * from "./BadgeEntry.vue?vue&type=script&lang=js"
import style0 from "./BadgeEntry.vue?vue&type=style&index=0&id=341f87cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341f87cd",
  null
  
)

export default component.exports